export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-06.3391c1ba.jpg";